const { default: Image } = require('next/image')
const { useState } = require('react')

const PhotoBox = ({ src, width, height, alt, bro, ...props }) => {
  const [isShow, setIsShow] = useState(true)

  return (
    <>
      {isShow ? (
        <div>
          <Image src={src} width={width} height={height} alt={alt} onError={() => setIsShow(false)} {...props}></Image>
          {bro}
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default PhotoBox
